module.exports = __webpack_public_path__ + "img/amazon-firestick.fd7feebb.jpg";